import {omneticApi} from '@dms/api/base';

import {SendServiceNotificationEmail} from './types';

export const serviceInspectionNotificationApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    postSendCheckinEmailNotification: build.mutation<void, SendServiceNotificationEmail>({
      query: (queryArgs) => ({
        url: `/dms/v1/workshop/service-case/${queryArgs.serviceCaseId}/check-in/customer-message`,
        method: 'POST',
        body: queryArgs.body,
      }),
    }),
    postSendHandoverEmailNotification: build.mutation<void, SendServiceNotificationEmail>({
      query: (queryArgs) => ({
        url: `/dms/v1/workshop/service-case/${queryArgs.serviceCaseId}/handover/customer-message`,
        method: 'POST',
        body: queryArgs.body,
      }),
    }),
  }),
});

export const {
  usePostSendCheckinEmailNotificationMutation,
  usePostSendHandoverEmailNotificationMutation,
} = serviceInspectionNotificationApi;
